import { MODE } from '../../constants';
import SportsBook from '../SportsBook';

const LiveSportsBook = () => <SportsBook serviceId={MODE.IN_PLAY} />;

export default LiveSportsBook;
